import {
    Flex, Box, SimpleGrid, Image,
} from "@chakra-ui/react";
import React from "react";
import { StyleSheet, css } from "aphrodite";
import { useSelector } from "react-redux";

function NextconMembers () {
    
    const isMobile = useSelector(state=> state.windowSize.isMobile);

    const ColNum = isMobile ? 2 : 4;
    const ColNum2 = isMobile ? 2 : 3;

    const space = isMobile ? 6 : 20;

    return(
        <>
        <Box className={css(styles.head)}>
            <Flex className={css(styles.container)}>
                SITE-CAV TEAM 
            </Flex>
            <SimpleGrid columns={2}
                        spacing={6}
                        px={{ base: 4, md: 10 }}
                        maxWidth={{ base: "100%", md: "1000px" }}
                        margin="auto"
                        textAlign="center"
                        marginTop={5}
                        marginBottom={5}>

                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="BurakKantarci.jpg" alt="Burak Kantarci" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Burak Kantarci
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Principal Investigator and Research Director
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="husseinmouftah.jpg" alt="Hussein Mouftah" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Hussein Mouftah
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Co-PI and research co-director
                    </Flex>
                </Box>
            </SimpleGrid>

            <hr />
            <Flex className={css(styles.container)}>
                RESEARCH TEAM 
            </Flex>
            <SimpleGrid
                columns={ColNum}
                spacing={space}
                px={{ base: 4, md: 10 }}
                maxWidth={{ base: "100%", md: "1000px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={5}
            >
                
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="MelikeKantarci.jpg" alt="Melike Erol-Kantarci" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Melike Erol-Kantarci
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        University of Ottawa
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="LionelBriand.jpg" alt="Lionel Briand" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Lionel Briand
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        University of Ottawa
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Abdallah Shami.jpg" alt="Abdallah Shami" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Abdallah Shami
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Western University
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="BirsenDonmez.jpg" alt="Birsen Donmez" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Birsen Donmez
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        University of Toronto
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Claude D'Amours.png" alt="Claude D'Amours" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Claude D'Amours
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        University of Ottawa
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="ElizabethJudge.jpg" alt="Claude D'Amours" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Elizabeth Judge
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        University of Ottawa
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Guy-Vincent Jourdan.jpg" alt="Guy-Vincent Jourdan" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Guy-Vincent Jourdan
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        University of Ottawa
                    </Flex>
                </Box>                
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="XianbinWang.jpg" alt="Xianbin Wang" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Xianbin Wang
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Western University
                    </Flex>
                </Box>
            </SimpleGrid>

            <hr />
            
            <Flex className={css(styles.container)}>
                {"PROJECT MANAGEMENT AND ADMINISTRATION"}
            </Flex>
            <SimpleGrid
                columns={ColNum}
                spacing={space}
                px={{ base: 4, md: 10 }}
                maxWidth={{ base: "100%", md: "1000px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={5}
            >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="peter mackinnon.jpg" alt="Peter MacKinnon" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Peter MacKinnon
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Project Executive Manager
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="JBCover.jpg" alt="Jaipreet Bindra" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Jaipreet Bindra
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Commercialization Lead
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Elis.jpg" alt="Iraz Eliz Deniz" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Iraz Eliz Deniz
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Project Coordinator
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Iman Amini.png" alt="Iman Amini" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Iman Amini
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Project Manager-Integration Architect
                    </Flex>
                </Box>
            </SimpleGrid>

            <hr />

            <Flex className={css(styles.container)}>
                {"STRATEGIC ASSESSMENT COMMITEE"}
            </Flex>
            <SimpleGrid
                columns={ColNum2}
                spacing={space}
                px={{ base: 4, md: 10 }}
                maxWidth={{ base: "100%", md: "1000px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={5}
            >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="sonya.jpg" alt="Sonya Shorey" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Sonya Shorey
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        CEO Invest Ottawa
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="arda-ozgun.jpg" alt="Arda Ozgun" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Arda Ozgun
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        CEO Edge Signal
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="DamsNarayanan.png" alt="Dams Narayanan" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Dams Narayanan
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Director, CIO - Innovation & Strategy, Canada Post
                    </Flex>
                </Box>
            </SimpleGrid>

            <hr />

            <Flex className={css(styles.container)}>
                {"DIGITAL COMMUNICATION COORDINATOR"}
            </Flex>
            <SimpleGrid
                columns={1}
                spacing={space}
                px={{ base: 4, md: 10 }}
                maxWidth={{ base: "100%", md: "1000px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={5}
            >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="MuratArda.png" alt="Murat Arda Onsu" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Murat Arda Onsu
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        University of Ottawa
                    </Flex>
                </Box>
            </SimpleGrid>



            <hr />

            {isMobile ? 
        (<>
            <Flex className={css(styles.container)}>
                {""}
            </Flex>
            <Flex justifyContent="center">
                <Image
                    src="about us general.png"
                    style={{
                        align:'center',
                        width: '95%',
                        marginBottom:'10px',
                        display:'flex'
                    }}
                    />
            </Flex>
        </>) : 
        (<>
            <Flex className={css(styles.container)}>
                {""}
            </Flex>
            <Flex justifyContent="center">
                <Image
                    src="about us general.png"
                    style={{
                        align:'center',
                        width: '65%',
                        marginBottom:'10px',
                        display:'flex'
                    }}
                    />
            </Flex>
        </>)}


            

            <hr />

            <Flex className={css(styles.container)}>
                COLLABORATORS AND INDUSTRY BOARD
            </Flex>

            <Flex className={css(styles.subContainer)}>
                CANADA - ONTARIO
            </Flex>
            <Flex justifyContent="center">
                <Image
                    src="I-Ontario.png"
                    style={{
                        align:'center',
                        width: '45%',
                        marginTop:'10px',
                        marginBottom:'10px',
                        display:'flex',
                        maxWidth:"400px"
                    }}
                    />
            </Flex>
            
            <SimpleGrid
                columns={ColNum2}
                spacing={5}
                px={{ base: 4, md: 20 }}
                maxWidth={{ base: "100%", md: "1200px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={15}
            >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario Area-X.0-logo.png" alt="I-Ontario Area-X.0-logo.png" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>

                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario Aurrigo-Logo.png" alt="I-Ontario Aurrigo-Logo.png" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario ThinkRF.png" alt="I-Ontario ThinkRF" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario Edge Signal.png" alt="I-Ontario Edge Signal" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario Lytica.jpg" alt="I-Ontario Lytica" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario Quanser.jpg" alt="I-Ontario Quanser" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario s2e.jpg" alt="I-Ontario s2e" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Ontario canada post.png" alt="I-Ontario canada post" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
            </SimpleGrid>


            <Flex className={css(styles.subContainer)}>
                CANADA - ALBERTA
            </Flex>
            <Flex justifyContent="center">
                <Image
                    src="I-Alberta.png"
                    style={{
                        align:'center',
                        width: '45%',
                        marginTop:'10px',
                        marginBottom:'10px',
                        display:'flex',
                        maxWidth:"400px"
                    }}
                    />
            </Flex>
            
            <SimpleGrid
                columns={1}
                spacing={5}
                px={{ base: 4, md: 20 }}
                maxWidth={{ base: "100%", md: "1200px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={20}
            >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-Alberta Wedge.png" alt="I-Alberta Wedge" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
            </SimpleGrid>
            

            <Flex className={css(styles.subContainer)}>
                USA - CALIFORNIA
            </Flex>
            <Flex justifyContent="center">
                <Image
                    src="I-California.png"
                    style={{
                        align:'center',
                        width: '45%',
                        marginTop:'10px',
                        marginBottom:'10px',
                        display:'flex',
                        maxWidth:"400px"
                    }}
                    />
            </Flex>
            
            <SimpleGrid
                columns={1}
                spacing={5}
                px={{ base: 4, md: 20 }}
                maxWidth={{ base: "100%", md: "1200px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={5}
            >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="I-California Trusted Mobi.png" alt="I-California Trusted Mobi" className={css(styles.images_Industry)} />
                    </Flex>
                </Box>
            </SimpleGrid>


        </Box>
        </>
    )
};

const styles = StyleSheet.create({
    head: {
        maxWidth: '100vw',
        marginTop: "140px"
    },
    parent: {
        maxWidth: '100vw',
        textAlign: 'center'
    },
    container: {
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 30,
        margin: '1%',
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
        textAlign: 'center'
    },
    subContainer: {
        marginTop:"50px",
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 30,
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
        textAlign: 'center',
        textDecorationLine: 'underline',     
    },
    textbox: {
        margin: '2%',
        marginTop: '0%',
        textAlign: 'center',
        fontSize: 18,
        justifyContent: 'center',
        alignContent: 'center'
    },
    names: {
        fontWeight: 'bold',
        fontSize: 20
    },
    title: {
        fontSize: 18,
    },
    images: {
        width: '200px',
        height: '200px',
        fit: "fit",
        borderRadius: "100%"
    },

    images_Industry: {
        fit: "fit",
        maxHeight:"200px",
    },
    mobileImage: {
        width: "70%",
        borderRadius: "80%"
    }
})

export default NextconMembers